import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { trackTrace } from '@fora-monorepo/webapp-analytics';
import { RequestError } from '@fora-monorepo/employer-my-pages-common/types';

import { envConfig } from '../../../config';
import { setThunkError } from '../errorSlice';

/**
 * Catch thunk rejections and put error message in error state, to be displayed in error pages in non-prod environments
 */

export const handleThunkErrors: Middleware = (api: MiddlewareAPI) => next => action => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as RequestError;
    trackTrace(payload?.message || JSON.stringify(action.payload), SeverityLevel.Information);
    if (envConfig.devLogging) {
      api.dispatch(setThunkError(payload));
    } else {
      api.dispatch(
        setThunkError({
          code: payload.code,
        })
      );
    }
  }

  return next(action);
};
